"use strict";

const Components = require('./components.js');
const _ = require('lodash');
const SITE_RATIO = 1.5;
const SITE_HEIGHT = window.innerHeight;

class Global {
  set_layout_width() {
    const $html = $("html");

    function calc() {
      let maxWidth = SITE_HEIGHT * SITE_RATIO;
      if ($("body.desktop").length) {
        maxWidth = window.innerHeight * SITE_RATIO;
      }

      const unit = (maxWidth / 4);
      const breakA = unit * 3;
      const breakB = unit * 2;
      const breakC = unit * 1;

      if (window.innerWidth > maxWidth) {
        $html.removeClass(
          "breakpoint-a breakpoint-b breakpoint-c breakpoint-d"
        );
      }
      if (window.innerWidth < maxWidth && window.innerWidth > breakA) {
        $html
          .addClass("breakpoint-a")
          .removeClass("breakpoint-b breakpoint-c breakpoint-d");
      }
      if (window.innerWidth < breakA && window.innerWidth > breakB) {
        $html
          .addClass("breakpoint-a breakpoint-b")
          .removeClass("breakpoint-c breakpoint-d");
      }
      if (window.innerWidth < breakB && window.innerWidth > breakC) {
        $html
          .addClass("breakpoint-a breakpoint-b breakpoint-c")
          .removeClass("breakpoint-d");
      }
      if (window.innerWidth < breakC || window.innerWidth < 400) {
        $html.addClass("breakpoint-a breakpoint-b breakpoint-c breakpoint-d");
      }
    }
    $(window).resize(
      _.debounce(function() {
        calc();
      }, 500)
    );
    calc();
  }

  navigation() {
    $(".hamburger").click(function() {
      $("body").toggleClass("nav-active");
    });

    $(".main-nav .search-trigger").click(function() {
      $(".main-nav").toggleClass("search-active");
      $('.main-nav input[type="search"]').focus();
    });

    let $nav = $(".main-nav");
    let lastPos = 0,
      distance = 0;
    $(window).scroll(
      _.throttle(function() {
        let navHeight = $nav.innerHeight();

        if (window.scrollY < lastPos) {
          distance = distance + (lastPos - window.scrollY);
          if (distance > window.innerHeight / 2) {
            $nav.addClass("active");
          }
        } else {
          distance = 0
          $nav.removeClass("active");
        }

        let navColor = $(".featured-gallery .gallery").attr("data-color");
        let lastColor = navColor ? navColor : "black";
        if (window.scrollY > navHeight * 2) {
          $nav.addClass("attached");
          $("body")
            .removeClass("white-color-nav black-color-nav")
            .addClass("black-color-nav");
        } else {
          $nav.removeClass("attached");
          $("body")
            .removeClass("white-color-nav black-color-nav")
            .addClass(lastColor + "-color-nav");
        }
        lastPos = window.scrollY;
      }, 250)
    );
  }

  forms() {
    $("form input").focus(function() {
      let $this = $(this);
      $this.parent().addClass("active");
    });

    $("form input").blur(function() {
      let $this = $(this);
      if ($this.val() === "") {
        $this.parent().removeClass("active");
      }
    });
  }

  // when the user starts to press the tab key
  // we add a class to the website which will help
  // clearly highlight what is currently active
  check_for_tab() {
    $("body").keydown(function(e) {
      if (e.originalEvent.keyCode === 9) {
        $("body").addClass("outlines");
      }
    });
  }

  jump_to_top() {
    $('a[href="#jump-to-top"]').on("click.jump-to-top", event => {
      event.preventDefault();
      $("html,body").animate({
          scrollTop: 0
        },
        1000
      );
    });
  }

  // prevent a cross-site hack where they can impersonate your website
  add_noopener() {
    $('a[target="_blank"]').each(function() {
      $(this).attr("rel", "noopener");
    });
  }



  alternate_dual_image_sections() {
    let smallLarge = true;
    $(".side-by-side-images-section").each(function() {
      if (smallLarge) {
        $(this)
          .removeClass("largeSmall")
          .addClass("smallLarge");
      } else {
        $(this)
          .removeClass("smallLarge")
          .addClass("largeSmall");
      }
      smallLarge = !smallLarge;
    });
  }

  text_section() {
    $(".text-section").each(function() {
      let details = $(this).find(".details");
      let container = $(this).find(".container");
      if (details.innerHeight() > container.innerHeight()) {
        container.css("min-height", details.innerHeight());
      }
    });
  }

  autoCloseNav() {
    $(window).scroll(
      _.debounce(function() {
        $("body").removeClass("nav-active");
      }, 100)
    );
  }

  popups() {
    $("a.popup-trigger").on("click.popup", function(event) {
      event.preventDefault();
      let href = $(this).attr("href");
      let $target = $(href);
      $target.addClass("active");
      $("body").addClass("popup-active");
    });

    $(".popup").each(function() {
      let $popup = $(this);
      $popup.find(".close").click(function() {
        $popup.removeClass("active");
        $("body").removeClass("popup-active");
      });
    });
  }

  mobileDrawers() {
    if ($(".breakpoint-c").length) {
      window.nav_drawers = [];
      $(".hidden-nav .drawer").each(function() {
        window.nav_drawers.push(
          new Components.Drawer(this, window.nav_drawers)
        );
      });
      window.footer_drawers = [];
      $(".main-footer .drawer").each(function() {
        window.footer_drawers.push(
          new Components.Drawer(this, window.footer_drawers)
        );
      });
    }
  }

  shareMenu() {
    $(".share-menu").each(function() {
      let $this = $(this);
      let $trigger = $this.find(".trigger");
      let $content = $this.find(".content");

      $trigger.click(function() {
        $content.slideToggle();
      });
      $content.slideUp();
    });
  }

  footerLogo() {
    let $template = $('<a class="beyond-your-base" href="http://beyondyourbase.com/" target="_blank"><h4>Beyond Your Base</h4><img src="/images/BYBWebsiteFooter.png" alt="Beyond Your Base Logo, redirects to the beyond your base sister site."/></a>');
    $('.main-footer .col').last().find('.contents').append($template.clone().addClass('desktop'));
    $('.main-footer .col').eq(2).find('.contents').append($template.clone().addClass('mobile'));
  }

  update100vh() {
    // const appHeight = () => document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
    // window.addEventListener('resize', appHeight);
    // appHeight();

    function calc(){
      $('.large-gallery .gallery').css('height', window.innerHeight);
    }
    calc();
    $(window).resize(_.debounce(function(){
      calc();
    }, 500));
  }

  unifyDrawerLabels() {
    function calc($el) {
      let max = 0;
      $el.css('width', 'auto');
      $el.each(function() {
        max = $(this).innerWidth() > max ? $(this).innerWidth() : max;
      });
      $el.css('width', max);
    }
    calc($('.hidden-nav .drawer .trigger'));
    calc($('.main-footer .drawer .trigger'));
    $(window).resize(_.debounce(() => {
      calc($('.hidden-nav .drawer .trigger'));
      calc($('.main-footer .drawer .trigger'));
    }, 500));
  }


  constructor() {
    this.check_for_tab();
    this.jump_to_top();
    this.add_noopener();
    this.update100vh();
    this.navigation();
    this.forms();

    this.set_layout_width();
    this.alternate_dual_image_sections();
    this.text_section();
    this.popups();
    this.mobileDrawers();
    this.shareMenu();
    this.footerLogo();
    this.unifyDrawerLabels();
    // this.autoCloseNav();

    let $pageBlocks = $(".page-content > *");
    $pageBlocks.last().addClass("last-block");
    $pageBlocks.first().addClass("first-block");

    $(".page-header + .fullscreen-gallery").addClass("page-gallery");
    $(".page-header + .fullscreen-gallery + .text-section").addClass("page-description");

    $(window).resize(_.debounce(function(){
      $(window).resize();
    }, 1000));
  }
}

module.exports = Global;